// components/ui/Button.tsx
// Chambers buttons — indigo primary (not ink), transparent bordered secondary.

import React from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: Variant;
    icon?: React.ReactNode;
    iconTrailing?: React.ReactNode;
    block?: boolean;
}

export function Button({
    variant = 'primary',
    icon,
    iconTrailing,
    block = false,
    children,
    className = '',
    ...props
}: ButtonProps) {
    const base = 'inline-flex items-center justify-center gap-2 px-5 py-3 text-[13px] font-medium tracking-[0.02em] transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

    const variants: Record<Variant, string> = {
        primary: 'bg-[#3730A3] text-white hover:bg-[#2E2780] border-0',
        secondary: 'bg-transparent text-[#3F3D39] border border-[#E8E4DB] hover:bg-[#F3EFE6]',
        ghost: 'bg-transparent text-[#6B6762] hover:text-[#1A1A1A] px-0',
    };

    return (
        <button
            {...props}
            className={`${base} ${variants[variant]} ${block ? 'w-full' : ''} ${className}`}
        >
            {icon}
            <span>{children}</span>
            {iconTrailing && <span className="font-serif text-[16px]">{iconTrailing}</span>}
        </button>
    );
}
